import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import styles from "../../../assets/css/modules/header/header.css";
import printStyles from "../../../assets/css/modules/print.css";
import { nonClaimsModules } from "../../../constants/SMEModulesToMatchOn";
import { Paths } from "../../../constants/UrlConstants";
import Content from "../../../content/Content";
import HeaderContent from "../../../content/Header";
import { shouldShowIfAllSMEModulesDontMatch } from "../../../helpers/SMEModules/smeModuleHelper";
import HomeAccountWrapper from "../../home/HomeAccountWrapper";
import InboxLink from "../../inbox/InboxLink";
import Logout from "../../logout/Logout";
import NotificationsLink from "../../notifications/NotificationsLink";
import { updateMenuItems } from "../actions/navigationMenuActions";
import HamburgerMenu from "../menu/HamburgerMenu";
import LargeScreenMenu from "../menu/LargeScreenMenu";
import Store from "./../../../content/Store";

export const mapStateToHeader = (state, props) => {
  const currentPolicy = state.policyReducer.selectedPolicy;
  const isInternational = currentPolicy && currentPolicy.IsInternational;
  const isSaga = currentPolicy && currentPolicy.IsSaga;
  const isFormat2 = currentPolicy && currentPolicy.IsFormat2;
  const isLapsed = currentPolicy && currentPolicy.IsLapsed;
  const isNotificationShown =
    !(isFormat2 || isInternational || isSaga) &&
    shouldShowIfAllSMEModulesDontMatch(currentPolicy, nonClaimsModules);
  const isHealthStoreShown = !(isInternational || isSaga);
  const policyCount =
    state.policyReducer.policyDetails &&
    state.policyReducer.policyDetails.Policies.length;
  const layout = state.layoutReducer && state.layoutReducer.layout;
  const internalView =
    state.policyReducer.policyDetails &&
    state.policyReducer.policyDetails.IsInternalView;
  return {
    CurrentPolicy: currentPolicy,
    isNotificationShown,
    isHealthStoreShown,
    isLapsed,
    isInternational,
    isSaga,
    policyCount,
    layout,
    isFormat2,
    internalView,
    ...props
  };
};
export class Header extends Component {
  componentDidUpdate() {
    this.props.updateMenuItems(Store.HeaderMenu);
  }

  componentDidMount() {
    this.props.updateMenuItems(Store.HeaderMenu);
  }

  render() {
    return (
      <React.Fragment>
        {this.props.internalView ? (
          <div id="top-banner" className={styles.internalTopBanner}>
            Internal View
          </div>
        ) : null}
        <header className={"header " + printStyles.noprint}>
          <div className="header-main">
            <div className="container axa-header-container">
              <HamburgerMenu />
              <nav
                className="nav overflowInherit float-right full-main-nav"
                aria-label="Top"
              >
                <ul className="nav-list">
                  <li className="topNavItem nav-item">
                    <InboxLink />
                  </li>
                  {this.props.isNotificationShown ? (
                    <li className="topNavItem nav-item">
                      <NotificationsLink />
                    </li>
                  ) : null}
                  {this.props.policyCount > 1 ? (
                    <HomeAccountWrapper {...this.props} />
                  ) : (
                    <li className="topNavItem nav-item">
                      <Link to={Paths.MyProfile}>
                        <i className="icon-man" />
                        <span className="hidden-sm-down">
                          <Content name={HeaderContent.MyProfileLink} />
                        </span>
                      </Link>
                    </li>
                  )}
                  <li className="topNavItem nav-item hidden-md-down">
                    <Logout />
                  </li>
                </ul>
              </nav>
              <Content
                names={[
                  HeaderContent.Link.ImageClass,
                  HeaderContent.Link.Src,
                  HeaderContent.Link.SrcSet,
                  HeaderContent.Link.SrcMin,
                  HeaderContent.Link.SrcMinSet,
                  HeaderContent.Link.AltText
                ]}
              >
                {(
                  linkImageClass,
                  linkSrc,
                  linkSrcSet,
                  linkSrcMin,
                  linkSrcMinSet,
                  linkAltText
                ) => (
                  <span>
                    <Link
                      id="brandHeader"
                      to={Paths.HomeRoot}
                      className={"logopadding " + styles.axalogo}
                    >
                      <img
                        className={linkImageClass}
                        src={linkSrc}
                        alt={linkAltText}
                        srcSet={linkSrcSet}
                      />
                    </Link>
                    {this.props.isSaga ? (
                      <Link
                        id="brandSagaHeader"
                        to={Paths.HomeRoot}
                        className={
                          "header-brand d-none d-md-flex float-right mt-3 " +
                          styles.sagaImage
                        }
                      >
                        <img
                          className={HeaderContent.SagaLink.Class}
                          src={HeaderContent.SagaLink.Src}
                          alt={HeaderContent.SagaLink.AltText}
                          srcSet={HeaderContent.SagaLink.SrcSet}
                        />
                      </Link>
                    ) : null}
                    <Link
                      id="brandHeaderSmall"
                      to={Paths.HomeRoot}
                      className={"logopadding " + styles.axalogosmall}
                    >
                      <img
                        className={linkImageClass}
                        src={linkSrcMin}
                        alt={linkAltText}
                        srcSet={linkSrcMinSet}
                      />
                    </Link>
                    {this.props.isSaga ? (
                      <Link
                        id="brandSagaHeaderSmall"
                        to={Paths.HomeRoot}
                        className={
                          "header-brand d-md-none d-lg-none float-right " +
                          styles.sagaImageSmall
                        }
                      >
                        <img
                          className={HeaderContent.SagaLink.Class}
                          src={HeaderContent.SagaLink.SrcMin}
                          alt={HeaderContent.SagaLink.AltText}
                          srcSet={HeaderContent.SagaLink.SrcMinSet}
                        />
                      </Link>
                    ) : null}
                  </span>
                )}
              </Content>
            </div>
            {this.props.isLapsed ? (
              <div className="axa-lapsed-plan">
                <span>
                  <Content name={HeaderContent.LapsedPlan} />
                </span>
              </div>
            ) : null}
          </div>
          <div className="header-main hidden-md-down">
            <div className="container">
              <LargeScreenMenu />
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToHeader, { updateMenuItems })(Header);
